import React from 'react'
import { MoodBoardProps } from './MoodBoard.types'
import { ImageComponentContent } from './MoodBoard.partials'
import Headline from '@atoms/Headline/Headline'
import CustomLink from '@atoms/CustomLink/CustomLink'

const MoodBoard = ({
  headline = '',
  link = { href: '', text: '' },
  images,
  imageClassName = 'moodBoardImg',
  backgroundStyle = '',
  headlineStyle = '',
  linkStyle = '',
  linkColorScheme = 'secondary',
  linkedImageStyle = ''
}: MoodBoardProps) => (
  <div className='max-w-screen-3xl relative mx-auto my-0 py-7 lg:pb-0 lg:pt-[70px]'>
    <div
      className={`${backgroundStyle} absolute left-0 top-0 z-0 h-full w-full sm:left-7 sm:h-full sm:w-[calc(100%-56px)] lg:left-14 lg:h-[83%] lg:w-[calc(100%-112px)]`}
    ></div>
    <div className='moodBoardLine'>
      <div className='relative mb-8 w-full px-4 sm:mb-12 sm:ml-[8.33333%] sm:max-w-[50%] lg:max-w-[41.6667%]'>
        <Headline tag='h2' className={`${headlineStyle}`}>
          {headline || ''}
        </Headline>
      </div>
    </div>
    <div className='moodBoardLine'>
      <div className='relative w-full py-0'>
        <div className='relative mb-5 h-[500px] sm:h-auto'>
          {images?.map((image, index) => {
            return (
              <figure
                key={`moodboardImage${index + 1}`}
                className={`${imageClassName}${index + 1}`}
              >
                {ImageComponentContent(image, index, linkedImageStyle)}
              </figure>
            )
          })}
        </div>
      </div>
    </div>
    {link.href && link.text && (
      <div className='moodBoardLine'>
        <div className='relative mt-0 w-full px-4 sm:-mt-[10%] sm:ml-[8.33333%] sm:max-w-[83.3333%] lg:-mt-[16%] lg:max-w-[33.3333%]'>
          <CustomLink
            colorScheme={linkColorScheme}
            className={`${linkStyle} m-0 w-fit`}
            href={link.href}
          >
            {link.text}
          </CustomLink>
        </div>
      </div>
    )}
  </div>
)

export default MoodBoard
